import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  MenuItem,
  Typography,
  Grid,
  Paper
} from "@mui/material";
import api from "../../utils/api";

const AddGateVisitorForm = ({ clubMemberCode }) => {
  const [formData, setFormData] = useState({
    ClubMemberID: clubMemberCode,
    FirstName: "",
    LastName: "",
    Description: "",
    ArrivalDate: "",
    DepartureDate: "",
    VehicleType: "",
    VehiclePlate: "",
    VisitorTypeID: "",
    Notes: "",
    PictureFile: null,
    AuthorizedBy: "", // NEW
    EnteredBy: ""     // NEW
  });

  const [types, setTypes] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (clubMemberCode) {
      // Set ClubMemberID
      setFormData((prev) => ({ ...prev, ClubMemberID: clubMemberCode }));

      // Fetch member info for AuthorizedBy
      api.get(`/members/${clubMemberCode}`).then((res) => {
        const fullName = `${res.data.FirstName?.trim() || ""} ${res.data.LastName?.trim() || ""}`.trim();
        setFormData((prev) => ({ ...prev, AuthorizedBy: fullName }));
      });
      
    }

    // Get logged-in user from localStorage for EnteredBy
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.Username) {
      setFormData((prev) => ({ ...prev, EnteredBy: user.Username.trim() }));
    }
  
    
  }, [clubMemberCode]);

  useEffect(() => {
    const loadTypes = async () => {
      const typeRes = await api.get("/gate-visitor-types");
      setTypes(typeRes.data);
    };
    loadTypes();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((f) => ({ ...f, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((f) => ({ ...f, PictureFile: file }));
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const submission = new FormData();

      submission.append("ClubMemberID", clubMemberCode.trim());

      Object.entries(formData).forEach(([key, value]) => {
        if (key !== "ClubMemberID" && value !== null && value !== undefined) {
          submission.append(key, value);
        }
      });

      await api.post("/gate-visitors", submission, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      alert("Visitor added.");

      setFormData({
        ClubMemberID: clubMemberCode,
        FirstName: "",
        LastName: "",
        Description: "",
        ArrivalDate: "",
        DepartureDate: "",
        VehicleType: "",
        VehiclePlate: "",
        VisitorTypeID: "",
        Notes: "",
        PictureFile: null,
        AuthorizedBy: formData.AuthorizedBy, // Keep filled
        EnteredBy: formData.EnteredBy        // Keep filled
      });

      setPreviewUrl(null);
    } catch (err) {
      console.error("Error submitting visitor:", err);
      alert("Failed to add visitor.");
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 2, mt: 2 }}>
      <Typography variant="h6" gutterBottom>Add Gate Visitor</Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField name="FirstName" label="First Name" fullWidth required value={formData.FirstName} onChange={handleChange} />
          </Grid>
          <Grid item xs={6}>
            <TextField name="LastName" label="Last Name" fullWidth required value={formData.LastName} onChange={handleChange} />
          </Grid>
          <Grid item xs={12}>
            <TextField name="Description" label="Description" fullWidth required value={formData.Description} onChange={handleChange} />
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="ArrivalDate"
              label="Arrival Date/Time"
              type="datetime-local"
              fullWidth
              required
              value={formData.ArrivalDate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              name="DepartureDate"
              label="Departure Date/Time"
              type="datetime-local"
              fullWidth
              value={formData.DepartureDate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField name="VehicleType" label="Vehicle Type" fullWidth value={formData.VehicleType} onChange={handleChange} />
          </Grid>
          <Grid item xs={6}>
            <TextField name="VehiclePlate" label="Vehicle Plate" fullWidth value={formData.VehiclePlate} onChange={handleChange} />
          </Grid>
          <Grid item xs={12}>
            <TextField name="VisitorTypeID" label="Visitor Type" fullWidth select value={formData.VisitorTypeID} onChange={handleChange}>
              {types.map((t) => (
                <MenuItem key={t.TypeID} value={t.TypeID}>{t.TypeName}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField name="Notes" label="Notes" fullWidth multiline rows={2} value={formData.Notes} onChange={handleChange} />
          </Grid>

          {/* Hidden but submitted */}
          <Grid item xs={12}>
  <TextField
    name="AuthorizedBy"
    label="Authorized By"
    fullWidth
    required
    value={formData.AuthorizedBy}
    onChange={handleChange}
  />
</Grid>




          <Grid item xs={12}>
            <Button variant="outlined" component="label">
              Upload Visitor Photo
              <input
                type="file"
                accept="image/*"
                capture="environment"
                hidden
                onChange={handleImageChange}
              />
            </Button>
          </Grid>

          {previewUrl && (
            <Grid item xs={12}>
              <img
                src={previewUrl}
                alt="Visitor Preview"
                style={{ maxWidth: "100%", maxHeight: 250, objectFit: "contain", marginTop: 8 }}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <Button variant="contained" type="submit">Submit</Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default AddGateVisitorForm;
